import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    A_VocTyp: "",
    A_VocTypName: "",
    A_VocNo: "",
    A_PostDt: new Date(), // dd/MM/yyyy
    A_ReceiptDt: new Date(), // dd/MM/yyyy
    A_Loc: "",
    A_LocName: "",
    A_DocStat: "ENTER",
    Truck: "",
    Driver: "",
  },
};

const SlicePendingDoDetailReport = createSlice({
  name: "SlicePendingDoDetailReport",
  initialState: { value: initialState },

  reducers: {
    //including   RESET ALL
    Set_PendingDoDetailReport_Init: (state) => {
      state.value = initialState;
    },

    //RESET HEAD
    Set_PendingDoDetailReport_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },

    Set_PendingDoDetailReport_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },
  },
});

export const {
  Set_PendingDoDetailReport_Init,
  Set_PendingDoDetailReport_HeadObject_Set,
  Set_PendingDoDetailReport_HeadObject_Init,
} = SlicePendingDoDetailReport.actions;
export default SlicePendingDoDetailReport.reducer;
